import React from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = ({ logout }) => {
  const history = useNavigate();

  const handleLogout = () => {
    logout(); // Call the provided logout function
    history('/login'); // Redirect to the login page or any other route
  };

  return <button onClick={handleLogout}>Logout</button>;
};

export default Logout;